import { render } from "./AppSelectMultiple.vue?vue&type=template&id=328da3b2"
import script from "./AppSelectMultiple.vue?vue&type=script&lang=js"
export * from "./AppSelectMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__